<template>
  <img
    class="kd-logo"
    :class="[`kd-logo-${shopName}`]"
    :src="logoUrl"
  >
</template>

<script>
const OPPERMANN = 'oppermann';
const HACH = 'hach';

export default {
  data() {
    return {
      hachLogo: require('../shared/assets/logos/hach-logo.svg'),
      oppermannLogo: require('../shared/assets/logos/oppermann-logo.svg'),
    };
  },
  computed: {
    shopName() {
      if (window.location.href.toLowerCase().includes(OPPERMANN.toLowerCase())) {
        return OPPERMANN;
      }
      return HACH;
    },
    logoUrl() {
      if (this.shopName === OPPERMANN) {
        return this.oppermannLogo;
      }
      return this.hachLogo;
    },
  }
};
</script>

<style lang="scss">
  .kd-logo {
    position: fixed;
    top: 40px;
    left: 40px;

    &-hach {
      height: 40px;
    }

    &-oppermann {
      // the logo is very long, therefore we need to reduce the height a bit
      height: 20px;
    }

    .kd--print & {
      display: none;
    }
  }
</style>
